/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEntraConsentLink200Response
 */
export interface GetEntraConsentLink200Response {
    /**
     * 
     */
    consentUrl?: string;
}

/**
 * Check if a given object implements the GetEntraConsentLink200Response interface.
 */
export function instanceOfGetEntraConsentLink200Response(value: object): value is GetEntraConsentLink200Response {
    return true;
}

export function GetEntraConsentLink200ResponseFromJSON(json: any): GetEntraConsentLink200Response {
    return GetEntraConsentLink200ResponseFromJSONTyped(json, false);
}

export function GetEntraConsentLink200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraConsentLink200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'consentUrl': json['consentUrl'] == null ? undefined : json['consentUrl'],
    };
}

export function GetEntraConsentLink200ResponseToJSON(json: any): GetEntraConsentLink200Response {
    return GetEntraConsentLink200ResponseToJSONTyped(json, false);
}

export function GetEntraConsentLink200ResponseToJSONTyped(value?: GetEntraConsentLink200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consentUrl': value['consentUrl'],
    };
}

